import { useState } from 'react'
import { HiHome, HiChatAlt2, HiLocationMarker, HiHeart } from 'react-icons/hi'
import { IoMdChatbubbles } from 'react-icons/io'
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube, FaTiktok, FaTumblr, FaDiscord } from 'react-icons/fa'

import Relation from '../../components/relation/Relation'
import Social from '../../components/buttons/Social'
import './home.css'
import UserAppContext from '../../hook/UserAppContext'

const Home = ({isHome}) => {

      const [relationship, setRelationship] = useState(false)
      if(!isHome) return 

      const {user, data} = UserAppContext()
      const {infordata, banners, relation, social} = user.user

      const name = infordata.data || infordata.name === '' ? data.info.name : infordata.name
      const avatar = infordata.data || infordata.avatar === '' ? data.info.avatar : infordata.avatar
      const status = infordata.data || infordata.status === '' ? data.info.status : infordata.status
      const about = infordata.data || infordata.about === '' ? data.info.about : infordata.about
      const id_xat = infordata.data || infordata.id_xat === '' ? data.info.id_xat : infordata.id_xat
      const location = infordata.data || infordata.location === '' ? data.info.location : infordata.location
      const banner = banners.data ? data.banner.image : banners[0].image 
      const banner_title = banners.data ? data.banner.title : banners[0].title
      
      const showCard = () => {
            setRelationship(true)
      }

      return (
            <div className={isHome ? "pager_content show" : "pager_content"}>
                  <div className="wrapper_home">
                        <div className="pager_banner">
                              <img src={banner} alt={banner_title} />
                        </div>
                        <div className="pager_container">
                              <div className="home_header">
                                    <div className="home_header__aside">
                                          <div className="home_aside__avatar">
                                                <img src={avatar} alt={name} />
                                          </div>
                                          <div className="home_aside__menu">
                                                <a href={infordata.data || infordata.homepage === '' ? "https://xat.com" : infordata.homepage} target="_blank" rel="noreferrer" data-tooltip="Homepage"><HiHome /></a>
                                                <a href={infordata.data || infordata.xat_room === '' ? "https://xat.com" : infordata.xat_room} target="_blank" rel="noreferrer" data-tooltip="Xatroom"><IoMdChatbubbles /></a>
                                                <a href={infordata.data || infordata.forum === '' ? "https://forum.xat.com" : infordata.forum} target="_blank" rel="noreferrer" data-tooltip="Forum"><HiChatAlt2 /></a>
                                          </div>
                                    </div>
                                    <div className="home_header__section">
                                          <div className="home_user__data">
                                                <div className="user_data__nick">
                                                      <h2 className="bg_grad">{name}</h2>
                                                      <span>{id_xat}</span>
                                                </div>
                                                <p>{status}</p>
                                                <div className="location">
                                                      <HiLocationMarker />
                                                      <span>{location}</span>
                                                </div>
                                          </div>
                                          <div className="home_user__about">
                                                <p>{about}</p>
                                          </div>
                                    </div>
                              </div>
                              
                              <div className={relationship ? "relation_content show" : "relation_content"}>
                                    <Relation isRelationship={relationship} isSetRelation={setRelationship}/>
                              </div>
                              {
                                    (!relation.data) 
                                          ?
                                                <button className="relation_show" onClick={() => showCard()}>
                                                      <HiHeart />
                                                      <span>Relation</span>
                                                </button>
                                          : ''
                              }
                              {
                                    (!social.data)
                                          ?
                                                <div className="home_networks">
                                                      <div className="networks_title">
                                                            <span>Social Media</span>
                                                      </div>
                                                      <div className="networs_menu">
                                                            <Social link={social.data || social.facebook === '' ? data.social.facebook : social.facebook} color={"btn_social facebook"} icon={<FaFacebookF/>}/>
                                                            <Social link={social.data || social.twitter === '' ? data.social.twitter : social.twitter} color={"btn_social twitter"} icon={<FaTwitter/>}/>
                                                            <Social link={social.data || social.instagram === '' ? data.social.instagram : social.instagram} color={"btn_social instagram"} icon={<FaInstagram/>}/>
                                                            <Social link={social.data || social.youtube === '' ? data.social.youtube : social.youtube} color={"btn_social youtube"} icon={<FaYoutube/>}/>
                                                            <Social link={social.data || social.tiktok === '' ? data.social.tiktok : social.tiktok} color={"btn_social tiktok"} icon={<FaTiktok/>}/>
                                                            <Social link={social.data || social.tumblr === '' ? data.social.tumblr : social.tumblr} color={"btn_social tumblr"} icon={<FaTumblr/>}/>
                                                            <Social link={social.data || social.discord === '' ? data.social.discord : social.discord} color={"btn_social discord"} icon={<FaDiscord/>}/>
                                                      </div>
                                                </div>
                                          : ""
                              }
                              
                        </div>
                        
                  </div>
            </div>
      )
}

export default Home
